import { ISport, IMotorsportsLiveScore } from "@sky-it-livedata/livedata-sports-design-system";

import { LiveScoreQuery } from "../types";

import { isValidLiveScoreObject } from "./typeguards";

import { WidgetError, ErrorName } from "../../../utils/errors";
import { CreateLiveScoreWidgetInputSchema} from 'cdk/graphql';
import { getTransformedDay, IdayType } from "./utils";

const transformer = (obj: LiveScoreQuery): IMotorsportsLiveScore  => {
  if (isValidLiveScoreObject(obj)) {
    CreateLiveScoreWidgetInputSchema().parse(obj.data.getLiveScoreWidget, {reportInput: true});

    const { currentDay, nextDay, previousDay } = obj.data.getLiveScoreWidget;

    const transformedObject = {
      previousDay: getTransformedDay({
        day: previousDay as ISport[],
        type: IdayType.FULL,
      }),
      currentDay: getTransformedDay({
        day: currentDay as ISport[],
        type: IdayType.FULL,
      }),
      nextDay: getTransformedDay({
        day: nextDay as ISport[],
        type: IdayType.FULL,
      }),
    };

    return transformedObject as IMotorsportsLiveScore;
  } else {
    throw new WidgetError<ErrorName>({
      name: "NO_VALID_DATA",
      message:
        "Invalid transformer input, Error in LiveScoreQuery object",
      data: obj,
    });
  }
};

export default transformer;
